/**
 * Rakuten Tracking — Captura de ranSiteID
 *
 * Este script lê o parâmetro `ranSiteID` da URL quando o visitante chega,
 * cria o cookie no padrão Rakuten e salva os dados como atributos
 * do carrinho para que o backend os receba junto com o pedido.
 *
 * IMPORTANTE: A Rakuten fornece a tag oficial para criação do cookie.
 * Este script complementa essa tag salvando os dados no carrinho Shopify.
 */

(function () {
  "use strict";

  console.log("[Rakuten] Script de captura rodando...");

  // ──────────────────────────────────────────────────────────────────────────
  // 1. Ler parâmetros da URL
  // ──────────────────────────────────────────────────────────────────────────
  var params = new URLSearchParams(window.location.search);
  var ranSiteID = params.get("ranSiteID");

  console.log("[Rakuten] ranSiteID capturado:", ranSiteID);

  if (!ranSiteID) {
    // Sem parâmetro Rakuten na URL — nada a fazer
    return;
  }

  // ──────────────────────────────────────────────────────────────────────────
  // 2. Registrar timestamp de landing
  //    Formato Rakuten: YYYYMMDD_HHmm  (ex: 20260310_1841)
  // ──────────────────────────────────────────────────────────────────────────
  var now = new Date();
  var pad = function (n) { return n < 10 ? "0" + n : "" + n; };
  var landingTimestamp =
    now.getFullYear().toString() +
    pad(now.getMonth() + 1) +
    pad(now.getDate()) +
    "_" +
    pad(now.getHours()) +
    pad(now.getMinutes());

  // Valor do cookie no formato esperado pela Rakuten
  var cookieValue = "ald:" + landingTimestamp + "|atrv:" + ranSiteID;

  // ──────────────────────────────────────────────────────────────────────────
  // 3. Gravar cookie (validade: 30 dias)
  //    NOTA: A tag oficial da Rakuten faz isso automaticamente.
  //    Este bloco serve como fallback caso a tag ainda não esteja ativa.
  // ──────────────────────────────────────────────────────────────────────────
  var expires = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie =
    "rmStoreGateway=" +
    encodeURIComponent(cookieValue) +
    "; expires=" +
    expires +
    "; path=/; SameSite=Lax";

  // ──────────────────────────────────────────────────────────────────────────
  // 4. Salvar como atributos do carrinho Shopify
  //    Esses atributos viajam junto com o pedido e chegam no webhook
  //    do servidor como order.note_attributes
  // ──────────────────────────────────────────────────────────────────────────
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes: {
        rakuten_site_id: ranSiteID,
        rakuten_landing_time: landingTimestamp,
        rakuten_cookie_value: cookieValue
      }
    })
  }).catch(function (err) {
    // Falha silenciosa — não impacta a experiência do cliente
    console.debug("[Rakuten] Falha ao salvar atributos do carrinho:", err);
  });
})();
